"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCVCurrentSection = exports.cvSectionValidationSchema = exports.cvSectionValidationMap = exports.cvEditParamsSchema = exports.cvEditingSectionSchema = exports.getGeneratedCVFromCV = exports.cvSchema = exports.renderCvPayloadSchema = exports.jsonValueSchema = exports.cvSensitiveInfoSchema = exports.cvLanguageSchema = void 0;
exports.parseRenderCvPayload = parseRenderCvPayload;
exports.transformGeneratedCVToFullCV = transformGeneratedCVToFullCV;
const zod_1 = __importDefault(require("zod"));
const cv_1 = require("../utils/cv");
exports.cvLanguageSchema = zod_1.default.object({
    language: zod_1.default.string(),
    level: zod_1.default.string().describe('The level of the language'),
});
exports.cvSensitiveInfoSchema = zod_1.default.object({
    firstName: zod_1.default.string(),
    lastName: zod_1.default.string(),
    email: zod_1.default.string().nullable(),
    phone: zod_1.default.string(),
});
exports.jsonValueSchema = zod_1.default.lazy(() => zod_1.default.union([
    zod_1.default.string(),
    zod_1.default.number(),
    zod_1.default.boolean(),
    zod_1.default.null(),
    zod_1.default.array(exports.jsonValueSchema),
    zod_1.default.record(zod_1.default.string(), exports.jsonValueSchema),
]));
function isRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function isRenderPayload(value) {
    if (!isRecord(value)) {
        return false;
    }
    const locale = value.locale;
    if (!isRecord(locale)) {
        return false;
    }
    const templateParams = exports.jsonValueSchema.safeParse(value.templateParams);
    return (typeof value.interviewId === 'string' &&
        typeof value.template === 'string' &&
        templateParams.success &&
        typeof locale.name === 'string' &&
        typeof locale.codeShort === 'string' &&
        typeof locale.codeLong === 'string');
}
exports.renderCvPayloadSchema = zod_1.default.custom(value => isRenderPayload(value), 'Invalid render payload. Expected FullCVWithTemplate JSON.');
function parseRenderCvPayload(payload) {
    return exports.renderCvPayloadSchema.parse(payload);
}
const cvPersonalInfoSchema = zod_1.default.object({
    postalCode: zod_1.default.string().nullable().describe('Postal code of the user'),
    location: zod_1.default.string().nullable().describe('City of the user'),
    jobTitle: zod_1.default.string().describe('Job title of the user'),
    hasDriverLicense: zod_1.default.boolean().describe('Whether the user has a driver license or not'),
    driverLicenseTypes: zod_1.default
        .string()
        .nullable()
        .describe('Types of driver license the user has (A, AM, B, C, D, E, etc.). Required if the user has a driver license. Prefix with "Permis" according to the language of the user, if he didn\'t already.'),
    hobbiesAndInterests: zod_1.default.array(zod_1.default.string()).nullable().describe('Hobbies and interests of the user'),
    openToTraining: zod_1.default.boolean().nullable().default(false),
    gender: zod_1.default.string().nullable().describe('Gender of the user (homme/femme) for text inflection'),
    mobility: zod_1.default.object({
        isMobile: zod_1.default.boolean().describe('Whether the user is mobile or not'),
        range: zod_1.default
            .string()
            .nullable()
            .describe('Range or cities the user is willing to move to (optional)'),
        radius: zod_1.default.number().nullable().describe('Radius of the mobility in km around the location'),
    }),
});
const cvExperienceSchema = zod_1.default.object({
    company: zod_1.default
        .string()
        .describe('Name of the company where the user worked. Preserve proper nouns and official company names as-is. NEVER include dates, job titles, or locations here.'),
    location: zod_1.default.string().describe('City where the user worked. NEVER include dates, company names, or job titles here.'),
    title: zod_1.default
        .string()
        .describe('Job title strictly. NEVER include dates, years, periods (e.g. do NOT write "Technicien 2020-2022" or "(depuis 2021)"), companies, or locations in this field as there are dedicated fields for them.'),
    missions: zod_1.default
        .string()
        .describe('Mission, responsibilities and achievements of the user in the company. IMPORTANT: Use infinitive form without pronouns (e.g. "Développer des applications web" not "J\'ai développé des applications web"). Never use first-person conjugated sentences.'),
    startDate: zod_1.default
        .string()
        .nullable()
        .describe('The start date of the experience, formatted as YYYY-MM, or YYYY alone when only the year is known. NEVER invent a month.'),
    endDate: zod_1.default
        .string()
        .nullable()
        .describe('The end date of the experience, formatted as YYYY-MM (or YYYY alone when only the year is known) or null if it is the current experience (optional). NEVER invent a month.'),
});
const cvPersonalExperienceSchema = zod_1.default.object({
    description: zod_1.default.string().nullable().describe('Description of the personal experience'),
    title: zod_1.default
        .string()
        .describe('Title of the personal experience strictly. NEVER include dates, years, or periods in this field.'),
    location: zod_1.default
        .string()
        .nullable()
        .describe('City where the personal experience took place, only if explicitly stated. Null when unknown.'),
    startDate: zod_1.default
        .string()
        .nullable()
        .describe('The start date of the personal experience, formatted as YYYY-MM, or YYYY alone when only the year is known. NEVER invent a month.'),
    endDate: zod_1.default
        .string()
        .nullable()
        .describe('The end date of the personal experience, formatted as YYYY-MM (or YYYY alone when only the year is known) or null if it is the current experience (optional). NEVER invent a month.'),
});
const cvExperiencesSchema = zod_1.default.object({
    professional: zod_1.default.array(cvExperienceSchema).describe("The user's professional experiences."),
    personal: zod_1.default
        .array(cvPersonalExperienceSchema)
        .describe("The user's personal experiences (projects, associations, etc.)."),
});
const cvSkillsSchema = zod_1.default.object({
    skills: zod_1.default.array(zod_1.default.string()).describe('Skills of the user, both hard and soft'),
    strengths: zod_1.default
        .array(zod_1.default.string())
        .describe('Strengths of the user, how his/her colleagues would describe him/her'),
    preferedTasks: zod_1.default
        .array(zod_1.default.string())
        .describe('Tasks the user enjoys the most. Use infinitive form without pronouns.'),
    notPreferedTasks: zod_1.default
        .array(zod_1.default.string())
        .describe('Tasks the user enjoys the least. Use infinitive form without pronouns.'),
    languages: zod_1.default.array(exports.cvLanguageSchema).describe('Languages the user speaks'),
});
const cvSchoolSchema = zod_1.default.object({
    degree: zod_1.default
        .string()
        .nullable()
        .describe('Degree type of the user (e.g. CAP, BEP, BAC, BTS, Licence, Master, etc.), null if no degree is mentioned. NEVER include dates, school names, or years in this field.'),
    school: zod_1.default
        .string()
        .describe('Name of the school. Preserve proper nouns and official names as-is (e.g. "Université de Nantes", "MIT"). Only translate the language of the name if it has an official French equivalent. NEVER include dates or diploma names here.'),
    name: zod_1.default
        .string()
        .describe('Name of the training/formation program / diploma strictly. NEVER include dates, years, periods (e.g. do NOT write "Électricité 2018-2020"), or school names here.'),
    acquiredSkills: zod_1.default
        .array(zod_1.default.string())
        .nullable()
        .describe('Description of the skills acquired at the school. Use infinitive form without pronouns.'),
    location: zod_1.default
        .string()
        .nullable()
        .describe('City of the school, only if explicitly stated by the candidate. Null when unknown.'),
    degreeStartedAt: zod_1.default
        .string()
        .nullable()
        .describe('Start date of the formation, formatted as YYYY-MM, or YYYY alone when only the year is known. NEVER invent a month.'),
    degreeObtainedAt: zod_1.default
        .string()
        .nullable()
        .describe('Date of the degree acquisition, formatted as YYYY-MM, or YYYY alone when only the year is known. NEVER invent a month.'),
});
const cvCertificationSchema = zod_1.default.object({
    certification: zod_1.default.string().nullable().describe('Name of the certification'),
    issuingOrganization: zod_1.default
        .string()
        .nullable()
        .describe('Name of the organization that issued the certification'),
    certificationObtainedAt: zod_1.default
        .string()
        .nullable()
        .describe('Date of the certification acquisition, formatted as YYYY-MM, or YYYY alone when only the year is known. NEVER invent a month.'),
    acquiredSkills: zod_1.default
        .array(zod_1.default.string())
        .nullable()
        .describe('Specific skills or authorizations this certification grants'),
});
const cvEducationSchema = zod_1.default.object({
    schools: zod_1.default.array(cvSchoolSchema).describe('Schools and training centers of the user'),
    certifications: zod_1.default.array(cvCertificationSchema).describe('Certifications of the user'),
});
exports.cvSchema = zod_1.default
    .object({
    personalInfo: cvPersonalInfoSchema,
    experiences: cvExperiencesSchema,
    skills: cvSkillsSchema,
    education: cvEducationSchema,
    isCompleted: zod_1.default.boolean().describe('Whether the CV is completed or not'),
    summary: zod_1.default
        .string()
        .describe('Summary of the CV. Must be strictly factual about the candidate. NEVER include editorial notes, reflections, or uncertainty comments (e.g. do NOT write "à préciser" or "à confirmer").'),
    question: zod_1.default.string().nullable().describe('Follow up question'),
    isReconversion: zod_1.default
        .boolean()
        .describe('Whether the candidate is in a career change / reconversion situation.'),
    complementaryInfo: zod_1.default
        .object({
        hasRQTH: zod_1.default.boolean().describe('Whether the candidate has RQTH (handicap worker status)'),
        mentions: zod_1.default
            .array(zod_1.default.string())
            .default([])
            .describe('Additional factual mentions: vehicle ("Véhiculé"), immediate availability ("Disponible immédiatement"), workstation adaptations, schedule constraints. NEVER duplicate information already in personalInfo (do NOT repeat driver license / "Permis", city, mobility radius, or hobbies here). NEVER put verification notes, uncertainty memos, or comments such as "à préciser", "à confirmer", or "période approximative".'),
    })
        .default({ hasRQTH: false, mentions: [] })
        .describe('Complementary information about the candidate'),
})
    .describe("The user's CV");
const cleanStr = (v) => {
    if (v == null || v === 'null')
        return '';
    const trimmed = v.trim();
    if ((0, cv_1.isNotCommunicated)(trimmed))
        return '';
    return (0, cv_1.stripAiReflections)(trimmed);
};
const cleanNullable = (v) => {
    if (v == null || v === 'null')
        return null;
    const trimmed = v.trim();
    if ((0, cv_1.isNotCommunicated)(trimmed))
        return null;
    const cleaned = (0, cv_1.stripAiReflections)(trimmed);
    return cleaned === '' ? null : cleaned;
};
function transformGeneratedCVToFullCV(cv, sensitiveInfo, locale, defaultPictureBase64) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { personalInfo, experiences, education, skills: skillsAndLanguages, summary } = cv;
    const { languages, ...skills } = skillsAndLanguages;
    return {
        ...cv,
        ...personalInfo,
        ...sensitiveInfo,
        pictureBase64: defaultPictureBase64 || cv.pictureBase64 || null,
        summary: summary ? (0, cv_1.stripAiReflections)(summary) : '',
        isReconversion: (_a = cv.isReconversion) !== null && _a !== void 0 ? _a : false,
        location: cleanStr(personalInfo.location),
        mobilityRadius: (_c = (_b = personalInfo.mobility) === null || _b === void 0 ? void 0 : _b.radius) !== null && _c !== void 0 ? _c : null,
        mobilityRange: (_e = (_d = personalInfo.mobility) === null || _d === void 0 ? void 0 : _d.range) !== null && _e !== void 0 ? _e : null,
        postalCode: cleanNullable(personalInfo.postalCode),
        jobTitle: cleanStr(personalInfo.jobTitle),
        hasDriverLicense: personalInfo.hasDriverLicense || false,
        driverLicenseTypes: (_f = personalInfo.driverLicenseTypes) !== null && _f !== void 0 ? _f : null,
        isMobile: (_h = (_g = personalInfo.mobility) === null || _g === void 0 ? void 0 : _g.isMobile) !== null && _h !== void 0 ? _h : false,
        openToTraining: (_j = personalInfo.openToTraining) !== null && _j !== void 0 ? _j : false,
        gender: (_k = personalInfo.gender) !== null && _k !== void 0 ? _k : null,
        hobbiesAndInterests: (personalInfo.hobbiesAndInterests || [])
            .map(h => cleanStr(h))
            .filter(Boolean),
        experiences: experiences.professional.map(exp => ({
            location: cleanStr(exp.location),
            company: cleanStr(exp.company),
            title: (0, cv_1.stripDatesAndMetadataFromTitle)(cleanStr(exp.title)),
            missions: cleanStr(exp.missions),
            startDate: cleanStr(exp.startDate),
            endDate: cleanNullable(exp.endDate),
        })),
        personalExperiences: experiences.personal.map(exp => ({
            title: (0, cv_1.stripDatesAndMetadataFromTitle)(cleanStr(exp.title)),
            description: cleanStr(exp.description),
            location: exp.location ? cleanStr(exp.location) : null,
            startDate: cleanStr(exp.startDate),
            endDate: cleanNullable(exp.endDate),
        })),
        languages: languages.map(lang => ({
            language: cleanStr(lang.language),
            level: cleanStr(lang.level),
        })),
        education: [
            ...(education.schools || []).map(school => ({
                school: cleanStr(school.school),
                name: cleanNullable(school.name ? (0, cv_1.stripDatesAndMetadataFromTitle)(school.name) : null),
                degree: cleanStr(school.degree ? (0, cv_1.stripDatesAndMetadataFromTitle)(school.degree) : null),
                location: school.location ? cleanStr(school.location) : null,
                acquiredSkills: (school.acquiredSkills || []).map(s => cleanStr(s)).filter(Boolean),
                degreeStartedAt: cleanNullable(school.degreeStartedAt),
                degreeObtainedAt: cleanNullable(school.degreeObtainedAt),
            })),
            ...(education.certifications || []).map(certif => ({
                school: cleanStr(certif.issuingOrganization),
                name: null,
                degree: cleanStr(certif.certification ? (0, cv_1.stripDatesAndMetadataFromTitle)(certif.certification) : null),
                location: null,
                acquiredSkills: (certif.acquiredSkills || []).map(s => cleanStr(s)).filter(Boolean),
                degreeStartedAt: null,
                degreeObtainedAt: cleanNullable(certif.certificationObtainedAt),
            })),
        ],
        competences: (skills.skills || skills.competences || []).map(s => cleanStr(s)).filter(Boolean),
        strengths: (skills.strengths || []).map(s => cleanStr(s)).filter(Boolean),
        preferedTasks: (skills.preferedTasks || []).map(t => cleanStr(t)).filter(Boolean),
        notPreferedTasks: (skills.notPreferedTasks || []).map(t => cleanStr(t)).filter(Boolean),
        locale,
        hasRQTH: cv.complementaryInfo.hasRQTH,
        complementaryMentions: (cv.complementaryInfo.mentions || [])
            .filter(mention => Boolean(mention) && !(0, cv_1.isInternalAiNote)(mention))
            .map(mention => (0, cv_1.stripAiReflections)(mention))
            .filter(mention => {
            var _a, _b, _c;
            return Boolean(mention) &&
                !(0, cv_1.isInternalAiNote)(mention) &&
                !(0, cv_1.isDuplicateMention)(mention, {
                    hasDriverLicense: personalInfo.hasDriverLicense,
                    driverLicenseTypes: personalInfo.driverLicenseTypes,
                    location: personalInfo.location,
                    postalCode: personalInfo.postalCode,
                    isMobile: (_a = personalInfo.mobility) === null || _a === void 0 ? void 0 : _a.isMobile,
                    mobilityRadius: (_b = personalInfo.mobility) === null || _b === void 0 ? void 0 : _b.radius,
                    mobilityRange: (_c = personalInfo.mobility) === null || _c === void 0 ? void 0 : _c.range,
                });
        }),
    };
}
const getGeneratedCVFromCV = (cv) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const professional = (cv.experiences || []).map(exp => {
        var _a, _b, _c, _d, _e, _f;
        return ({
            company: (_a = exp.company) !== null && _a !== void 0 ? _a : '',
            location: (_b = exp.location) !== null && _b !== void 0 ? _b : '',
            title: (_c = exp.title) !== null && _c !== void 0 ? _c : '',
            missions: (_d = exp.missions) !== null && _d !== void 0 ? _d : '',
            startDate: (_e = exp.startDate) !== null && _e !== void 0 ? _e : null,
            endDate: (_f = exp.endDate) !== null && _f !== void 0 ? _f : null,
        });
    });
    const personal = (cv.personalExperiences || []).map(p => {
        var _a, _b, _c, _d, _e;
        return ({
            description: (_a = p.description) !== null && _a !== void 0 ? _a : null,
            title: (_b = p.title) !== null && _b !== void 0 ? _b : '',
            location: (_c = p.location) !== null && _c !== void 0 ? _c : null,
            startDate: (_d = p.startDate) !== null && _d !== void 0 ? _d : null,
            endDate: (_e = p.endDate) !== null && _e !== void 0 ? _e : null,
        });
    });
    const schools = (cv.education || []).map(e => {
        var _a, _b, _c, _d, _e, _f, _g;
        return ({
            degree: (_a = e.degree) !== null && _a !== void 0 ? _a : null,
            school: (_b = e.school) !== null && _b !== void 0 ? _b : '',
            name: (_c = e.name) !== null && _c !== void 0 ? _c : '',
            location: (_d = e.location) !== null && _d !== void 0 ? _d : null,
            acquiredSkills: (_e = e.acquiredSkills) !== null && _e !== void 0 ? _e : [],
            degreeStartedAt: (_f = e.degreeStartedAt) !== null && _f !== void 0 ? _f : null,
            degreeObtainedAt: (_g = e.degreeObtainedAt) !== null && _g !== void 0 ? _g : null,
        });
    });
    const languages = (cv.languages || []).map(l => {
        var _a, _b;
        return ({
            language: (_a = l.language) !== null && _a !== void 0 ? _a : '',
            level: (_b = l.level) !== null && _b !== void 0 ? _b : '',
        });
    });
    const personalInfo = {
        postalCode: (_a = cv.postalCode) !== null && _a !== void 0 ? _a : null,
        location: (_b = cv.location) !== null && _b !== void 0 ? _b : null,
        jobTitle: (_c = cv.jobTitle) !== null && _c !== void 0 ? _c : '',
        hasDriverLicense: (_d = cv.hasDriverLicense) !== null && _d !== void 0 ? _d : false,
        driverLicenseTypes: (_e = cv.driverLicenseTypes) !== null && _e !== void 0 ? _e : null,
        openToTraining: (_f = cv.openToTraining) !== null && _f !== void 0 ? _f : false,
        gender: (_g = cv.gender) !== null && _g !== void 0 ? _g : null,
        hobbiesAndInterests: (_h = cv.hobbiesAndInterests) !== null && _h !== void 0 ? _h : null,
        mobility: {
            isMobile: (_j = cv.isMobile) !== null && _j !== void 0 ? _j : false,
            range: (_k = cv.mobilityRange) !== null && _k !== void 0 ? _k : null,
            radius: (_l = cv.mobilityRadius) !== null && _l !== void 0 ? _l : null,
        },
    };
    const skills = {
        skills: cv.competences || [],
        strengths: cv.strengths || [],
        preferedTasks: cv.preferedTasks || [],
        notPreferedTasks: cv.notPreferedTasks || [],
        languages,
    };
    const education = {
        schools,
        certifications: [],
    };
    return {
        personalInfo,
        experiences: { professional, personal },
        skills,
        education,
        isCompleted: false,
        summary: (_m = cv.summary) !== null && _m !== void 0 ? _m : null,
        question: null,
        isReconversion: (_o = cv.isReconversion) !== null && _o !== void 0 ? _o : false,
        complementaryInfo: {
            hasRQTH: (_p = cv.hasRQTH) !== null && _p !== void 0 ? _p : false,
            mentions: (_q = cv.complementaryMentions) !== null && _q !== void 0 ? _q : [],
        },
    };
};
exports.getGeneratedCVFromCV = getGeneratedCVFromCV;
exports.cvEditingSectionSchema = zod_1.default.enum([
    'personalInfos',
    'competences',
    'languages',
    'experiences',
    'personalExperiences',
    'education',
    'hobbiesAndInterests',
    'summary',
    'complementaryInfo',
    'strengths',
    'preferedTasks',
    'notPreferedTasks',
]);
exports.cvEditParamsSchema = zod_1.default.object({
    userId: zod_1.default.string(),
    sectionType: exports.cvEditingSectionSchema,
    sectionContent: zod_1.default.unknown().optional(), // Content of the specific section being edited
    /** Language of the CV being edited (chosen by the candidate). Optional:
     * the server falls back to the user's locale when absent. */
    localeCode: zod_1.default.string().optional(),
});
exports.cvSectionValidationMap = {
    personalInfos: zod_1.default.object({ content: cvPersonalInfoSchema }),
    experiences: zod_1.default.object({ content: zod_1.default.array(cvExperienceSchema) }),
    personalExperiences: zod_1.default.object({ content: zod_1.default.array(cvPersonalExperienceSchema) }),
    education: zod_1.default.object({ content: zod_1.default.array(cvSchoolSchema) }),
    competences: zod_1.default.object({ content: zod_1.default.array(zod_1.default.string()) }),
    languages: zod_1.default.object({ content: zod_1.default.array(exports.cvLanguageSchema) }),
    hobbiesAndInterests: zod_1.default.object({ content: zod_1.default.array(zod_1.default.string()) }),
    summary: zod_1.default.object({ content: zod_1.default.string() }),
    complementaryInfo: zod_1.default.object({
        content: zod_1.default.object({
            hasRQTH: zod_1.default.boolean(),
            complementaryMentions: zod_1.default.array(zod_1.default.string()),
        }),
    }),
    strengths: zod_1.default.object({ content: zod_1.default.array(zod_1.default.string()) }),
    preferedTasks: zod_1.default.object({ content: zod_1.default.array(zod_1.default.string()) }),
    notPreferedTasks: zod_1.default.object({ content: zod_1.default.array(zod_1.default.string()) }),
};
exports.cvSectionValidationSchema = zod_1.default.object(exports.cvSectionValidationMap);
const getCVCurrentSection = (cvSection, currentSection) => {
    var _a;
    switch (currentSection) {
        case 'personalInfos':
            const { location, jobTitle, hasDriverLicense, driverLicenseTypes, openToTraining, gender, mobility, } = cvSection.personalInfos.content;
            return {
                postalCode: cleanNullable(cvSection.personalInfos.content.postalCode),
                location: cleanStr(location),
                jobTitle: cleanStr(jobTitle),
                hasDriverLicense: hasDriverLicense || false,
                driverLicenseTypes: driverLicenseTypes !== null && driverLicenseTypes !== void 0 ? driverLicenseTypes : null,
                isMobile: (_a = mobility.isMobile) !== null && _a !== void 0 ? _a : false,
                openToTraining: openToTraining !== null && openToTraining !== void 0 ? openToTraining : false,
                gender: gender !== null && gender !== void 0 ? gender : null,
                mobilityRadius: mobility.radius,
                mobilityRange: mobility.range,
            };
        case 'competences':
            return { competences: cvSection.competences.content };
        case 'languages':
            return {
                languages: cvSection.languages.content.map(language => ({
                    language: cleanStr(language.language),
                    level: cleanStr(language.level),
                })),
            };
        case 'experiences':
            return {
                experiences: cvSection.experiences.content.map(experience => ({
                    company: cleanStr(experience.company),
                    location: cleanStr(experience.location),
                    title: (0, cv_1.stripDatesAndMetadataFromTitle)(cleanStr(experience.title)),
                    missions: experience.missions,
                    startDate: cleanStr(experience.startDate),
                    endDate: cleanNullable(experience.endDate),
                })),
            };
        case 'personalExperiences':
            return {
                personalExperiences: cvSection.personalExperiences.content.map(personalExperience => {
                    var _a;
                    return ({
                        title: (0, cv_1.stripDatesAndMetadataFromTitle)(cleanStr(personalExperience.title)),
                        description: cleanStr(personalExperience.description),
                        location: (_a = personalExperience.location) !== null && _a !== void 0 ? _a : null,
                        startDate: cleanStr(personalExperience.startDate),
                        endDate: cleanNullable(personalExperience.endDate),
                    });
                }),
            };
        case 'education':
            return {
                education: cvSection.education.content.map(education => {
                    var _a;
                    return ({
                        school: cleanStr(education.school),
                        degree: cleanStr(education.degree ? (0, cv_1.stripDatesAndMetadataFromTitle)(education.degree) : null),
                        name: cleanNullable(education.name ? (0, cv_1.stripDatesAndMetadataFromTitle)(education.name) : null),
                        location: (_a = education.location) !== null && _a !== void 0 ? _a : null,
                        acquiredSkills: education.acquiredSkills || [],
                        degreeStartedAt: cleanNullable(education.degreeStartedAt),
                        degreeObtainedAt: cleanNullable(education.degreeObtainedAt),
                    });
                }),
            };
        case 'hobbiesAndInterests':
            return { hobbiesAndInterests: cvSection.hobbiesAndInterests.content };
        case 'summary':
            return { summary: cvSection.summary.content };
        case 'complementaryInfo':
            return {
                hasRQTH: cvSection.complementaryInfo.content.hasRQTH,
                complementaryMentions: cvSection.complementaryInfo.content.complementaryMentions,
            };
        case 'strengths':
            return { strengths: cvSection.strengths.content };
        case 'preferedTasks':
            return { preferedTasks: cvSection.preferedTasks.content };
        case 'notPreferedTasks':
            return { notPreferedTasks: cvSection.notPreferedTasks.content };
        default:
            throw new Error(`Unknown section: ${currentSection}`);
    }
};
exports.getCVCurrentSection = getCVCurrentSection;
__exportStar(require("./cv-schema-compliance"), exports);
